import {globalCatch} from "../../../_services/global-catch";
import {SET_MAD_CERT_APPLICATION_STATUS} from "./constants";
import {studentAcademicProgramsTitleApi} from "../../../_services/expedient-service";
import {toastService} from "../../../_services/toast-service";
import {t} from "../../../_i18n"

export const setMadCertApplicationStatus = payload => ({type: SET_MAD_CERT_APPLICATION_STATUS, payload});

export const getMadCertApplicationStatus = (studentId) => globalCatch.catch( async dispatch => {
    const madCertApplication = await(await studentAcademicProgramsTitleApi()).studentAcademicProgramTitleDocumentControllerShowByStudent(studentId);
    dispatch(setMadCertApplicationStatus(madCertApplication));
})

export const uploadMadCertPaymentReceipt  = (studentId, file, academicProgramId) => globalCatch.catch( async dispatch => {
    const response = {error: null, data: null};

    try {
        response.data = await(await studentAcademicProgramsTitleApi()).studentAcademicProgramTitleDocumentControllerStore(studentId, {file, academicProgramId});
        toastService.showToast({message:t("Solicitud enviada correctamente"), type:'info'});
    } catch (e) {
        if (e?.body?.message) {
            response.error = e.body.message;
            toastService.showToast({message: e.body.message, type: 'danger'});
        } else if (e?.body?.errors) {
            const errorObject = e.body.errors;
            const errorKeys = Object.keys(errorObject);
            const message = errorObject[errorKeys[0]][0];
            toastService.showToast({message: message , type: 'danger'});
        } else {
            toastService.showToast({message: t("Ha ocurrido un error"), type: 'danger'});
        }
    }

    return response;
})
